module.exports = __webpack_public_path__ + "img/reset-password-v2-dark.ec5c8c19.svg";